export default __webpack_public_path__ + "static/media/app-13.20607b46.png";